/* RESPONSIBLE TEAM: team-channels */
import Model, { attr } from '@ember-data/model';

export default class SwitchSettings extends Model {
  @attr('string') appId;
  @attr('boolean') repliesToStories;
  @attr('boolean') mentionsInStories;
  @attr('boolean') setExpectationsBot;
}
